// Main entry point - export UI components and styles

// Export all UI functionality
export * from './ui/index';

// Global type declaration for mocha-detailed-json-reporter-ui
declare global {
  interface Window {
    MochaDetailedReporterUI: {
      renderTestReport: (containerId: string, reportData: any, options?: any) => void;
      clearReport?: (containerId: string) => void;
    };
  }
}

// Helper function to render with external UI library (always expects it to be available)
export function renderWithExternalUI(containerId: string, reportData: any, options: any = {}): void {
  window.MochaDetailedReporterUI.renderTestReport(containerId, reportData, {
    expandFailures: true,
    showConsoleLogs: true,
    theme: 'light',
    ...options
  });
}
